import "./ReviewStep.css";

function ReviewStep({
    providerData,
    previousStep,
    nextStep,
}) {

    const providerType = providerData.providerType;

    const isFoodProvider =
        providerType === "Home Chef" ||
        providerType === "Restaurant" ||
        providerType === "Hotel";

    const isBakery =
        providerType === "Bakery";

    const isCatering =
        providerType === "Catering";

    const isProvision =
        providerType === "Provision Store";

    const openingTime =

        `${providerData.business?.openingHour || "--"}:` +

        `${providerData.business?.openingMinute || "--"} ` +

        `${providerData.business?.openingPeriod || ""}`;

    const closingTime =

        `${providerData.business?.closingHour || "--"}:` +

        `${providerData.business?.closingMinute || "--"} ` +

        `${providerData.business?.closingPeriod || ""}`;

    return (

        <div className="review-step">

            <h2>

                Review Your Application

            </h2>

            <p>

                Please review all your information before continuing.

            </p>

            {/* =======================================
                    Owner Details
            ======================================= */}

            <div className="review-card">

                <h3>

                    👤 Owner Details

                </h3>

                <div className="review-grid">

                    <div className="review-item">

                        <span className="label">

                            Name

                        </span>

                        <span>

                            {providerData.owner?.name}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Phone

                        </span>

                        <span>

                            {providerData.owner?.phone}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Email

                        </span>

                        <span className="review-email">

                            {providerData.owner?.email}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Gender

                        </span>

                        <span>

                            {providerData.owner?.gender}

                        </span>

                    </div>

                </div>

            </div>
                        {/* =======================================
                    Business Details
            ======================================= */}

            <div className="review-card">

                <h3>

                    🏪 Business Details

                </h3>

                <div className="review-grid">

                    <div className="review-item">

                        <span className="label">
                            Provider Type
                        </span>

                        <span>
                            {providerType}
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            Business Name
                        </span>

                        <span>
                            {providerData.business?.businessName}
                        </span>

                    </div>

                    <div className="review-item review-full">

                        <span className="label">
                            Description
                        </span>

                        <span>
                            {providerData.business?.description}
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            Opening Time
                        </span>

                        <span>
                            {openingTime}
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            Closing Time
                        </span>

                        <span>
                            {closingTime}
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            Experience
                        </span>

                        <span>
                            {providerData.business?.experience} Years
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            Weekly Holiday
                        </span>

                        <span>
                            {providerData.business?.weeklyHoliday}
                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            GST
                        </span>

                        <span>

                            {providerData.business?.hasGST === "Yes"

                                ? providerData.business?.gstNumber

                                : "Not Available"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">
                            FSSAI
                        </span>

                        <span>

                            {providerData.business?.hasFSSAI === "Yes"

                                ? providerData.business?.fssaiNumber

                                : "Not Available"}

                        </span>

                    </div>

                    {/* ===============================
                        HOME CHEF / RESTAURANT / HOTEL
                    =============================== */}

                    {isFoodProvider && (

                        <>

                            <div className="review-item">

                                <span className="label">
                                    Food Type
                                </span>

                                <span>
                                    {providerData.business?.foodType}
                                </span>

                            </div>

                            <div className="review-item">

                                <span className="label">
                                    Delivery Radius
                                </span>

                                <span>
                                    {providerData.business?.deliveryRadius} km
                                </span>

                            </div>

                            <div className="review-item review-full">

                                <span className="label">
                                    Cuisines
                                </span>

                                <span>

                                    {providerData.business?.cuisines?.length

                                        ? providerData.business.cuisines.join(", ")

                                        : "Not Selected"}

                                </span>

                            </div>

                        </>

                    )}

                    {/* ===============================
                        BAKERY
                    =============================== */}

                    {isBakery && (

                        <>

                            <div className="review-item review-full">

                                <span className="label">
                                    Bakery Categories
                                </span>

                                <span>

                                    {providerData.business?.categories?.length

                                        ? providerData.business.categories.join(", ")

                                        : "Not Selected"}

                                </span>

                            </div>

                        </>

                    )}

                    {/* ===============================
                        CATERING
                    =============================== */}

                    {isCatering && (

                        <>

                            <div className="review-item">

                                <span className="label">
                                    Minimum Order
                                </span>

                                <span>
                                    {providerData.business?.minimumOrder}
                                </span>

                            </div>

                            <div className="review-item">

                                <span className="label">
                                    Maximum Guests
                                </span>

                                <span>
                                    {providerData.business?.maximumGuests}
                                </span>

                            </div>

                            <div className="review-item review-full">

                                <span className="label">
                                    Event Types
                                </span>

                                <span>

                                    {providerData.business?.eventTypes?.length

                                        ? providerData.business.eventTypes.join(", ")

                                        : "Not Selected"}

                                </span>

                            </div>

                        </>

                    )}

                    {/* ===============================
                        PROVISION STORE
                    =============================== */}

                    {isProvision && (

                        <>

                            <div className="review-item review-full">

                                <span className="label">
                                    Store Categories
                                </span>

                                <span>

                                    {providerData.business?.categories?.length

                                        ? providerData.business.categories.join(", ")

                                        : "Not Selected"}

                                </span>

                            </div>

                        </>

                    )}

                    {/* ===============================
                        SERVICES
                    =============================== */}

                    <div className="review-item review-full">

                        <span className="label">
                            Services
                        </span>

                        <span>

                            {providerData.business?.services?.length

                                ? providerData.business.services.join(", ")

                                : "Not Selected"}

                        </span>

                    </div>

                </div>

            </div>
                        {/* =======================================
                    Address Details
            ======================================= */}

            <div className="review-card">

                <h3>

                    📍 Address Details

                </h3>

                <div className="review-grid">

                    <div className="review-item">

                        <span className="label">

                            Door No

                        </span>

                        <span>

                            {providerData.address?.doorNo || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Street

                        </span>

                        <span>

                            {providerData.address?.street || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Landmark

                        </span>

                        <span>

                            {providerData.address?.landmark || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Area

                        </span>

                        <span>

                            {providerData.address?.area || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            City

                        </span>

                        <span>

                            {providerData.address?.city || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            State

                        </span>

                        <span>

                            {providerData.address?.state || "-"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Pincode

                        </span>

                        <span>

                            {providerData.address?.pincode || "-"}

                        </span>

                    </div>

                </div>

            </div>

            {/* =======================================
                    Bank Details
            ======================================= */}

            <div className="review-card">

                <h3>

                    🏦 Bank Details

                </h3>

                <div className="review-grid">

                    <div className="review-item">

                        <span className="label">

                            Account Holder

                        </span>

                        <span>

                            {providerData.bank?.accountHolder}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Bank Name

                        </span>

                        <span>

                            {providerData.bank?.bankName}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Account Number

                        </span>

                        <span>

                            ********

                            {providerData.bank?.accountNumber?.slice(-4)}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            IFSC Code

                        </span>

                        <span>

                            {providerData.bank?.ifscCode}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            UPI ID

                        </span>

                        <span>

                            {providerData.bank?.upiId ||

                                "Not Provided"}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Account Type

                        </span>

                        <span>

                            {providerData.bank?.accountType}

                        </span>

                    </div>

                    <div className="review-item">

                        <span className="label">

                            Verification

                        </span>

                        <span
                            className={
                                providerData.bank?.isVerified
                                    ? "verified"
                                    : "not-verified"
                            }
                        >

                            {providerData.bank?.isVerified
                                ? "✅ Verified"
                                : "❌ Not Verified"}

                        </span>

                    </div>

                </div>

            </div>

            {/* =======================================
                    Buttons
            ======================================= */}

            <div className="step-buttons">

                <button
                    type="button"
                    onClick={previousStep}
                >
                    ← Back
                </button>

                <button
                    type="button"
                    onClick={nextStep}
                >
                    Continue →
                </button>

            </div>

        </div>

    );

}

export default ReviewStep;